import { ADDRESS_TYPES } from '../models/Address';

class AddressHelper {
  static getAddressType(type) {
    switch (type) {
      case ADDRESS_TYPES.HOUSE:
        return 'Domicilio';
      case ADDRESS_TYPES.WORK:
        return 'Trabajo';
      case ADDRESS_TYPES.HOLIDAY_HOUSE:
        return 'Balneario';
      case ADDRESS_TYPES.OTHER:
        return 'Otro';
      default:
        return null;
    }
  }

  static deSerializeType(type) {
    switch (type) {
      case 'Domicilio':
        return ADDRESS_TYPES.HOUSE;
      case 'Trabajo':
        return ADDRESS_TYPES.WORK;
      case 'Balneario':
        return ADDRESS_TYPES.HOLIDAY_HOUSE;
      case 'Otro':
        return ADDRESS_TYPES.OTHER;
      default:
        return null;
    }
  }

  static getAddressSecondLine(address) {
    let result = address.doorNumber || '';
    if (address.letter && address.letter.trim()) result = result.concat(` ${address.letter}`);
    if (address.bis) result = result.concat(' BIS');
    if (address.extraInfo1) result = result.concat(` ${address.extraInfo1.field.label} ${address.extraInfo1.value}`);
    if (address.extraInfo2) result = result.concat(` ${address.extraInfo2.field.label} ${address.extraInfo2.value}`);
    if (address.firstCorner) result = result.concat(` Esq. ${address.firstCorner}`);
    return result;
  }
}

export { AddressHelper };



// WEBPACK FOOTER //
// ./src/helpers/AddressHelper.js